// Admin portal user management types

export type AdminRole = 'super-admin' | 'admin' | 'content-editor' | 'viewer'
export type AdminUserStatus = 'active' | 'pending' | 'suspended'

export interface AdminPortalUser {
  id: string
  email: string
  name: string
  role: AdminRole
  status: AdminUserStatus

  // Event access (for non-super-admin roles)
  eventAccess?: string[] // Array of master event IDs they can access

  // Metadata
  createdAt: string
  lastLogin?: string
  invitedBy?: string

  // Profile
  profileImage?: string
}

export interface AdminRolePermissions {
  role: AdminRole
  label: string
  description: string
  permissions: {
    canManageAdminUsers: boolean
    canManageAllEvents: boolean
    canManageEventContent: boolean
    canViewOnly: boolean
    requiresEventSelection: boolean
  }
}

export const ADMIN_ROLES: AdminRolePermissions[] = [
  {
    role: 'super-admin',
    label: 'Super Admin',
    description: 'Full access to all events and admin users',
    permissions: {
      canManageAdminUsers: true,
      canManageAllEvents: true,
      canManageEventContent: true,
      canViewOnly: false,
      requiresEventSelection: false,
    },
  },
  {
    role: 'admin',
    label: 'Admin',
    description: 'Full access to selected events',
    permissions: {
      canManageAdminUsers: false,
      canManageAllEvents: false,
      canManageEventContent: true,
      canViewOnly: false,
      requiresEventSelection: true,
    },
  },
  {
    role: 'content-editor',
    label: 'Content Editor',
    description: 'Edit content for selected events',
    permissions: {
      canManageAdminUsers: false,
      canManageAllEvents: false,
      canManageEventContent: true,
      canViewOnly: false,
      requiresEventSelection: true,
    },
  },
  {
    role: 'viewer',
    label: 'Viewer',
    description: 'View-only access to selected events',
    permissions: {
      canManageAdminUsers: false,
      canManageAllEvents: false,
      canManageEventContent: false,
      canViewOnly: true,
      requiresEventSelection: true,
    },
  },
]
